import React, { memo } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import { Button } from 'react-bootstrap';

const Heading = tw.h1`text-black`;

function RemoveCart(props) {
  return (
    <motion.div
      initial={{ x: "700px", opacity: 0, scale: 0.5 }}
      animate={{ x: 0, opacity: 1, scale: 1 }}
      tw="justify-center  flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none "
    >
      {" "}
      <div tw="relative" className=" col-md-7 col-lg-6 col-xl-5  ">
        <div
          className="box "
          tw="shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none "
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
             borderColor: "#daab20"
          }}
        >
          <div
            className="box-inner"
            tw="flex-wrap sm:flex items-start justify-center items-center p-2 border-solid rounded-t"
            style={{ borderColor: "#daab20", borderWidth: "1px" }}
          >
             <div className="position-absolute top-0 end-0" onClick={() => props.setShowModal("")}>
              <i
                className="bi bi-x m-2"
                tw="text-3xl text-gray-600 cursor-pointer"
              ></i>
            </div>
            <div className="text-center">
              <h6>
                <small>Are you sure you want to remove this item?</small>
              </h6>
              <div className="pt-4 py-sm-3 d-flex justify-content-center gap-2">
                <Button className="bg-secondary border-secondary" onClick={() => props.setShowModal("")}>
                  Cancel </Button>
                <Button className="btn-delete" onClick={() => props.removeItemFromCart(props.showModal)}>
                  OK </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
export default memo(RemoveCart);
